export function parseAuditJson<T = Record<string, unknown>>(
    json?: string | null
): T | null {
    if (!json)
        return null;

    try {
        return JSON.parse(json) as T;
    } catch {
        return null;
    }
}

export function getAuditActionLabel(action: string): string {
    switch (action) {
        case "ArtworkUpdated":
            return "Artwork updated";

        case "ProvenanceUpdated":
            return "Provenance updated";

        case "ReferenceCreated":
            return "Reference added";

        case "ReferenceUpdated":
            return "Reference updated";

        case "ReferenceDeleted":
            return "Reference deleted";

        default:
            return action
                .replace(/([A-Z])/g, " $1")
                .trim();
    }
}

export function getAuditEntityLabel(
    entityType: string,
    entityId: string,
    rootEntityType?: string | null,
    rootEntityId?: string | null
): string {

    if (
        rootEntityType === "Artwork" &&
        rootEntityId
    ) {
        return `Artwork #${rootEntityId}`;
    }

    if (entityType === "Artwork") {
        return `Artwork #${entityId}`;
    }

    return `${entityType} #${entityId}`;
}
